import { IErrorResponse, InitiatedResponseData } from '../../../entity/interface/iErrorResponse';

class InitiatedError extends Error implements IErrorResponse<InitiatedResponseData> {
    public data: InitiatedResponseData;
    constructor(code: string | number, message?: string) {
        super(message);
        this.data = {
            code,
            message,
        };
    }
}

export default InitiatedError;
